import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        '& input': {
            padding: '8px 5px',
        },
        '& .MuiInputBase-root':{
            borderRadius:'8px',
            backgroundColor: 'transparent',
            '.lightTheme &': {
                backgroundColor: '#fff'
            }
        },


    },
    inner: {
        width: '100%',
    },
    inlineLabel: {
        gap: '8px',
        '& input': {
            padding: '6px 5px',
        },
        '& > .MuiTypography-root': {
            minWidth: '22px',
        },
        '& > .MuiFormControl-root, & > .MuiTextField-root': {
            flex: 1,
        },
    },
    label: {
        color: '#848581',
        fontWeight: '600'
    },
    icon: {
        color: '#BEBCB9',
    },
    wrap: {
        position:'relative',
        zIndex:1300
    }
}